import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import {
  AuthenticationService,
  GeneralService,
  CaseService,
} from "../../_services";
import { Utils } from "../../_helpers";
import { Observable } from "rxjs";

@Component({
  selector: "app-header",
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.scss"],
})
export class HeaderComponent implements OnInit {
  appTitle = "EPS";
  currUser = this.authService.currentUserValue;
  isCurrentUserAnonymous = this.currUser.username === "anonymous";
  canCurrentUserGoToLandingPage =
    this.currUser.role.id === 1 || this.currUser.role.id === 4;
  canGotoDataCollectionForms =
    this.currUser.role.id === 1 || this.currUser.role.id === 4;
  isNotPrincipal = this.currUser.role.id !== 2;
  hasReadCaseDefinitionPermission =
    this.currUser.role.permission_codes.includes("READ_CASE_DEFINITION") ||
    this.currUser.role.permission_codes.includes("ADMIN");
  returnUrl: string;
  analyticsExternalURL: string;
  isLoggedIn$: Observable<boolean>;
  avatarFirstInitial = this.utils.generateFirstInitalFromUserName(
    this.currUser.username
  );
  userDataLoaded = false;
  isCaseDefinitionDataLoaded = false;
  caseDefinitions: { id: number; name: string }[] = [];
  haveOneCaseDefinition = false;
  caseDefinition: { id: number; name: string };

  constructor(
    private router: Router,
    private utils: Utils,
    private authService: AuthenticationService,
    private generalService: GeneralService,
    private caseService: CaseService
  ) {
    this.isLoggedIn$ = this.authService.isLoggedIn;
  }

  ngOnInit() {
    this.getConfigs();
    if (this.hasReadCaseDefinitionPermission) {
      this.getCaseDefinitions();
    }
  }

  public generateDisplayEmail(): string {
    return this.currUser.email !== "" ? `${this.currUser.email}` : "My Account";
  }

  private getConfigs(): void {
    this.generalService.getConfigs().subscribe(
      (data) => {
        this.analyticsExternalURL = data.metabase_url;
        this.userDataLoaded = true;
      },
      (error) => {
        console.log(error.message);
      }
    );
  }

  private getCaseDefinitions(): void {
    this.isCaseDefinitionDataLoaded = false;
    this.caseService.getAllCaseDefinitions().subscribe(
      (data) => {
        if (data.length == 1) {
          console.log("we only got one");
          this.haveOneCaseDefinition = true;
          const singleCaseDefinition = data[0];
          this.caseDefinition = {
            id: singleCaseDefinition.id,
            name: singleCaseDefinition.name,
          };
        } else {
          console.log("got 0 or more than 1");
          this.haveOneCaseDefinition = false;
          this.caseDefinitions = data.map((cd) => {
            return { id: cd.id, name: cd.name };
          });
          this.caseDefinitions.sort((cd1, cd2) => {
            if (cd1.name < cd2.name) {
              return -1;
            } else if (cd1.name > cd2.name) {
              return 1;
            } else {
              return 0;
            }
          });
        }
        this.isCaseDefinitionDataLoaded = true;
      },
      (error) => {
        console.log(error.message);
      }
    );
  }

  public generateLinkToMetabase(): string {
    return this.analyticsExternalURL;
  }

  public logOut(): void {
    this.authService.logout();
    this.returnUrl = `login`;
    this.router.navigate([this.returnUrl]);
  }
}
